import React, { useEffect, useMemo, useRef, useState } from 'react';
import './MetricSelector.css';

export default function MetricSelector({ metrics, selectedMetrics, setSelectedMetrics, id }) {
  const [isOpen, setIsOpen] = useState(false);
  const [query, setQuery] = useState('');
  const containerRef = useRef(null);
  const normalizedQuery = query.trim().toLocaleLowerCase();
  const visibleMetrics = useMemo(() => metrics.filter(metric =>
    metric.label.toLocaleLowerCase().includes(normalizedQuery)
  ), [metrics, normalizedQuery]);
  const selectedKeys = useMemo(() => new Set(selectedMetrics.map(metric => metric.key)), [selectedMetrics]);

  useEffect(() => {
    const closeOnOutsideClick = event => {
      if (containerRef.current && !containerRef.current.contains(event.target)) setIsOpen(false);
    };
    const closeOnEscape = event => {
      if (event.key === 'Escape') setIsOpen(false);
    };
    document.addEventListener('mousedown', closeOnOutsideClick);
    document.addEventListener('keydown', closeOnEscape);
    return () => {
      document.removeEventListener('mousedown', closeOnOutsideClick);
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, []);

  const toggleMetric = metric => {
    setSelectedMetrics(previous => previous.some(selected => selected.key === metric.key)
      ? previous.filter(selected => selected.key !== metric.key)
      : [...previous, metric]);
  };

  return (
    <div className="metric-selector" ref={containerRef}>
      <button
        type="button"
        className="metric-selector__trigger"
        onClick={() => setIsOpen(open => !open)}
        aria-controls={`${id}-menu`}
        aria-expanded={isOpen}
      >
        Add/Remove Metrics
      </button>

      {isOpen && (
        <div className="metric-selector__menu" id={`${id}-menu`} role="dialog" aria-label="Metric selector">
          <label className="metric-selector__search-label" htmlFor={`${id}-search`}>Search metrics</label>
          <input
            id={`${id}-search`}
            className="metric-selector__search"
            type="search"
            value={query}
            onChange={event => setQuery(event.target.value)}
            placeholder="Search metrics..."
          />
          <div className="metric-selector__actions">
            <button type="button" onClick={() => setSelectedMetrics(metrics)}>Select all</button>
            <button type="button" onClick={() => setSelectedMetrics([])}>Clear all</button>
          </div>
          <div className="metric-selector__options">
            {visibleMetrics.length === 0 ? (
              <p className="metric-selector__empty">No metrics found</p>
            ) : visibleMetrics.map(metric => (
              <label key={metric.key} className="metric-selector__option">
                <input
                  type="checkbox"
                  checked={selectedKeys.has(metric.key)}
                  onChange={() => toggleMetric(metric)}
                />
                {metric.label}
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
